import React, { useEffect, useRef } from "react";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf";

// Set the workerSrc property
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ fileUrl, smallSize = false }) => {
  const canvasRef = useRef(null);
  const renderTaskRef = useRef(null);

  useEffect(() => {
    const loadPdf = async () => {
      if (renderTaskRef.current) {
        renderTaskRef.current.cancel(); // Cancel the previous render task if it exists
      }

      const loadingTask = pdfjs.getDocument(fileUrl);
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const scale = 1; // Initial scale
      const viewport = page.getViewport({ scale });

      // Set the desired width and calculate the appropriate height
      const desiredWidth = smallSize ? 600 : 1600;
      const scaleX = desiredWidth / viewport.width;
      const finalViewport = page.getViewport({ scale: scaleX });
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      canvas.width = finalViewport.width;
      canvas.height = finalViewport.height;

      const renderContext = {
        canvasContext: context,
        viewport: finalViewport,
      };
      const renderTask = page.render(renderContext);
      renderTaskRef.current = renderTask;

      renderTask.promise
        .then(() => {
          renderTaskRef.current = null; // Clear the reference after rendering is complete
        })
        .catch((error) => {
          if (error.name === "RenderingCancelledException") {
            console.log("Rendering cancelled", error.message);
          } else {
            console.error("Error during rendering", error);
          }
        });
    };

    loadPdf();

    return () => {
      if (renderTaskRef.current) {
        renderTaskRef.current.cancel(); // Cancel the render task on component unmount
      }
    };
  }, [fileUrl]);

  return (
    <div style={{ width: smallSize ? "600px" : "1600px", overflow: "hidden" }}>
      <canvas ref={canvasRef} style={{ width: "100%" }}></canvas>
    </div>
  );
};

export default PdfViewer;
